export function genNbsp(count) {
  return Array(count + 1).join('\u00A0');
}
//# sourceMappingURL=generatorNbsp.js.map
